import * as React from "react";
import {
  TextField,
  MessageBar,
  MessageBarType,
  ScrollablePane,
  IScrollablePane,
  Spinner,
  SpinnerType,
  Label,
  SpinnerSize
} from "office-ui-fabric-react";;
import "../css/Common.css";
import axios from "axios";
import aws = require("aws-sdk");
import Header from "./Header";
import MatterSearch from "./MatterSearch";
import Attachments from "./Attachments";
import { APIUrls } from "../environments/ConfigDetails";
import ReactDOM = require("react-dom");
import SuccessMessage from "./SuccessMessage";
import { v4 as uuid } from "uuid";
import SavedMatters from "./SavedMatters";
import SaveBtn from "./SaveBtn";
import Footer from "./Footer";
import SignIn from "./SignIn";
export interface SaveEmailProps {
  isItemChanged: boolean;
  savedMatters: any[];
  bucketCredentials;
  isLoggedIn: boolean;
}

export interface SaveEmailState {
  itemSubject: string;
  attachmentList: any[];
  selectedAttachments: any[];
  isErrorInUpload: boolean;
  uploadedKeyList: any[];
  errorMessage: string;
  recentMattersList: any[];
  selectedMatter: any;
  isProcessing: boolean;
  isStateChanged: boolean;
  isRecentMatterChanged: boolean;
  isRequiredFieldsEmpty: boolean;
  isSelectedAttachmentsChanged: boolean;
}

let isMounted = false;

class SaveEmail extends React.Component<SaveEmailProps, SaveEmailState> {
  private scrollablePane = React.createRef<IScrollablePane>()

  constructor(props, { }) {
    super(props, {});
    this.state = {
      itemSubject: Office.context.mailbox.item.subject,
      attachmentList: [],
      selectedAttachments: [],
      isErrorInUpload: false,
      uploadedKeyList: [],
      recentMattersList: [],
      selectedMatter: null,
      errorMessage: "",
      isProcessing: false,
      isStateChanged: false,
      isRecentMatterChanged: false,
      isRequiredFieldsEmpty: false,
      isSelectedAttachmentsChanged: false
    };
  }
  componentDidMount() {
    this.setState({ itemSubject: Office.context.mailbox.item.subject });
    isMounted = true;
  }
  componentWillUnmount() {
    isMounted = false;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.isItemChanged) {
      this.setState({
        isStateChanged: false,
        errorMessage: "",
        isRecentMatterChanged: false,
        isSelectedAttachmentsChanged: false,
        selectedMatter: null,
        selectedAttachments: [],
        isErrorInUpload: false,
        uploadedKeyList: [],
        recentMattersList: [],
        isProcessing: false
      });
    }
  }
  componentDidUpdate() { }
  render() {
    let { isProcessing } = this.state;
    return (
      <div>
        <Header
          title={`Matter Management`}
          isLoggedIn={this.props.isLoggedIn}
        />
        {isProcessing && (
          <Spinner
            type={SpinnerType.large}
            label={"Processing..."}
            ariaLive="assertive"
            style={{ marginTop: 175, fontFamily: "Lato" }}
            size={SpinnerSize.large}
          />
        )}

        {!isProcessing && (
          <ScrollablePane
            componentRef={() => this.scrollablePane}
            style={{ marginTop: 40, marginBottom: 60 }}
          >
            <SavedMatters
              savedMatters={this.props.savedMatters}
              isItemChanged={this.props.isItemChanged}
            />
            {this.state.errorMessage && (
              <MessageBar
                className="msg-bar"
                messageBarType={MessageBarType.error}
                isMultiline={true}
              >
                <span
                  style={{
                    fontFamily: "Lato",
                    fontWeight: "normal",
                    fontSize: 14
                  }}
                >
                  {this.state.errorMessage}
                </span>
              </MessageBar>
            )}
            {this.state.isRequiredFieldsEmpty && (
              <MessageBar
                className="msg-bar"
                messageBarType={MessageBarType.error}
                isMultiline={true}
              >
                <span
                  style={{
                    fontFamily: "Lato",
                    fontWeight: "normal",
                    fontSize: 14
                  }}
                >{`You must fill in all required fields`}</span>
                <span
                  style={{
                    color: "#D0021B",
                    fontFamily: "Lato",
                    fontWeight: "normal",
                    fontSize: 14
                  }}
                >
                  *
                </span>{" "}
                <span
                  style={{
                    fontFamily: "Lato",
                    fontWeight: "normal",
                    fontSize: 14
                  }}
                >{`to save to a matter.`}</span>
              </MessageBar>
            )}
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row" style={{ marginTop: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <Label
                    style={{
                      fontFamily: "Lato",
                      fontWeight: "normal",
                      color: "black",
                      fontSize: 16
                    }}
                  >
                    Subject of Email<span style={{ color: "#D0021B" }}>*</span>
                  </Label>
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <TextField
                    label=""
                    value={
                      this.state.isStateChanged
                        ? this.state.itemSubject
                        : Office.context.mailbox.item.subject
                    }
                    onChange={this.subjectOnChanged}
                    style={{
                      fontFamily: "Lato",
                      fontWeight: "normal",
                      color: "black",
                      fontSize: 14
                    }}
                    autoComplete={"off"}
                  />
                </div>
              </div>
              <div className="ms-Grid-row" style={{ marginTop: "35px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <Label
                    style={{
                      fontFamily: "Lato",
                      fontWeight: "normal",
                      color: "black",
                      fontSize: 16
                    }}
                  >
                    Select Matter<span style={{ color: "#D0021B" }}>*</span>
                  </Label>
                </div>
              </div>
            </div>
            <MatterSearch
              onMatterChanged={this.onMatterChanged}
              selectedMatter={this.state.selectedMatter}
              onRecentMatterChanged={this.onRecentMatterChanged}
              isItemChanged={
                this.state.isRecentMatterChanged
                  ? false
                  : this.props.isItemChanged
              }
            />
            <div className="ms-Grid" dir="ltr">
              <Attachments
                updateSelectedAttachmentList={this.updateSelectedAttachmentList}
                isItemChanged={
                  this.state.isSelectedAttachmentsChanged
                    ? false
                    : this.props.isItemChanged
                }
              />

              <br />
              <br />
              {this.state.isErrorInUpload && (
                <MessageBar
                  className="msg-bar"
                  messageBarType={MessageBarType.error}
                  isMultiline={false}
                >
                  <span
                    style={{
                      fontFamily: "Lato",
                      fontWeight: "normal",
                      fontSize: 14
                    }}
                  >{`Something went wrong. Please try again`}</span>
                </MessageBar>
              )}
            </div>
          </ScrollablePane>
        )}
        {!isProcessing && (
          <SaveBtn
            selectedAttachments={this.state.selectedAttachments}
            saveAttachments={this.saveAttachments}
          />
        )}
        {isProcessing && <Footer />}
      </div>
    );
  }

  saveAttachments = () => {
    let { selectedMatter, itemSubject, selectedAttachments } = this.state;
    if (selectedMatter !== null && itemSubject) {
      isMounted &&
        this.setState({
          isProcessing: true
        });

      if (Office.context.mailbox.item.attachments.length > 0) {
        if (
          selectedAttachments.length > 0 &&
          selectedAttachments.filter(x => x.isChecked).length > 0
        ) {
          //attachments are selected then get the attachment token
          this.getAttachmentToken();
        } else if (
          selectedAttachments.length > 0 &&
          selectedAttachments.filter(x => x.isChecked).length === 0
        ) {
          //not select any attachments
          let settings = Office.context.roamingSettings;
          let accessTokenObj = settings.get("accessTokenObj");
          this.postEmailPayLoadToMatter(accessTokenObj.access_token);
        } else if (selectedAttachments.length === 0) {
          //does not change default select - select all
          this.getAttachmentToken();
        }
      } else {
        let settings = Office.context.roamingSettings;
        let accessTokenObj = settings.get("accessTokenObj");
        this.postEmailPayLoadToMatter(accessTokenObj.access_token);
      }
    } else {
      //no any attachments for the selected item
      this.setState({
        isRequiredFieldsEmpty: true
      });
    }
  };
  //retrieve the attachment callback token
  getAttachmentToken = () => {
    try {
      // Use stored OAuth token for backend auth
      let settings = Office.context.roamingSettings;
      let accessTokenObj = settings.get("accessTokenObj");

      if (accessTokenObj && accessTokenObj.access_token) {
        this.uploadAttachmentsWithOfficeAPI(accessTokenObj.access_token);
      } else {
        console.error("No valid authentication token available");
        ReactDOM.render(<SignIn />, document.getElementById("container"));
      }
    } catch (error) {
      console.error("Error getting attachment token:", error);
      this.setState({ isProcessing: false });
    }
  };

  // New method using Office's attachment API instead of direct Graph calls
  uploadAttachmentsWithOfficeAPI = (backendAuthToken) => {
    if (this.props.bucketCredentials !== null) {
      this.uploadToS3WithOfficeAPI(backendAuthToken, this.props.bucketCredentials);
    } else {
      ReactDOM.render(<SignIn />, document.getElementById("container"));
    }
  };

  //upload selected attachments to S3 using Office API
  uploadToS3WithOfficeAPI = async (backendAuthToken, credentials) => {
    let { selectedAttachments } = this.state;
    try {
      if (selectedAttachments.length === 0) {
        // nothing changed - default select all
        let attachments = Office.context.mailbox.item.attachments;
        attachments.forEach(attachment => {
          if (
            selectedAttachments.filter(x => x.key === attachment.id).length ===
            0
          ) {
            selectedAttachments.push({
              key: attachment.id,
              isChecked: true,
              name: attachment.name,
              size: attachment.size,
              contentType: attachment.contentType
            });
          } else {
            selectedAttachments.find(
              x => x.key === attachment.id
            ).isChecked = true;
          }
        });
      }

      if (selectedAttachments.filter(x => x.isChecked).length > 0) {
        const uploadPromises = [];
        for (let i = 0; i < selectedAttachments.length; i++) {
          if (selectedAttachments[i].isChecked) {
            uploadPromises.push(
              this.uploadObjectWithOfficeAPI(
                selectedAttachments[i].key,
                selectedAttachments[i].name,
                credentials
              )
            );
          }
        }

        try {
          await Promise.all(uploadPromises);
        } catch (uploadError) {
          console.error('One or more uploads failed:', uploadError);
          this.setState({
            isProcessing: false,
            isErrorInUpload: true,
            errorMessage: "Failed to upload attachments. Please try again."
          });
          return;
        }
      }

      this.postEmailPayLoadToMatter(backendAuthToken);
    } catch (error) {
      console.error('Failed to upload to S3 with Office API...', error);
      this.setState({ isProcessing: false });
    }
  };

  //upload to aws s3 bucket using Office API
  uploadObjectWithOfficeAPI = (attachmentId, attachmentName, credentials) => {
    return new Promise((resolve, reject) => {
      let { uploadedKeyList } = this.state;
      try {
        if (uploadedKeyList.filter(x => x.AttachmentId === attachmentId).length === 0) {
          // Use Office's getAttachmentContentAsync instead of direct Graph calls
          Office.context.mailbox.item.getAttachmentContentAsync(
            attachmentId,
            (result) => {
              if (result.status === Office.AsyncResultStatus.Succeeded) {
                const s3 = new aws.S3({
                  accessKeyId: credentials.id,
                  secretAccessKey: credentials.key,
                  region: credentials.region
                });

                let UId = uuid();
                let body;

                if (result.value.format === 'base64') {
                  // Convert base64 to Buffer
                  body = Buffer.from(result.value.content, 'base64');
                } else {
                  // For text or other formats
                  body = result.value.content;
                }

                let uploadParams = {
                  Body: body,
                  Bucket: credentials.name,
                  Metadata: {
                    type: 'application/octet-stream',
                    name: attachmentName
                  },
                  Key: UId,
                  ContentType: 'application/octet-stream'
                };

                var request = s3.putObject(uploadParams);
                request.send((err) => {
                  if (err) {
                    console.error('Upload request has failed...', err);
                    reject(err);
                  } else {
                    if (
                      uploadedKeyList.filter(x => x.AttachmentId === attachmentId).length === 0
                    ) {
                      uploadedKeyList.push({
                        AttachmentId: attachmentId,
                        S3Key: UId,
                        Name: attachmentName
                      });
                      this.setState({ uploadedKeyList });
                    }
                    resolve({ attachmentId, s3Key: UId, name: attachmentName });
                  }
                });
              } else {
                console.error('Failed to get attachment content:', result.error);
                reject(result.error);
              }
            }
          );
        } else {
          // Attachment already uploaded, resolve immediately
          resolve({ attachmentId, alreadyUploaded: true });
        }
      } catch (error) {
        console.error('Failed to upload object with Office API:', error);
        reject(error);
      }
    });
  };

  //update state when matter is changed
  onMatterChanged = option => {
    let matter = null;
    if (option) {
      matter = {
        Id: option.key,
        text: option.text,
        url: option.url,
        date: "on " + this.getCurrentDate()
      };
    }
    isMounted &&
      this.setState({
        selectedMatter: matter,
        isRecentMatterChanged: true,
        errorMessage: "",
        isRequiredFieldsEmpty: false
      });
  };
  //update state when recent matter is changed
  onRecentMatterChanged = option => {
    let matter = null;
    if (option) {
      matter = {
        Id: option.key,
        text: option.text,
        url: "",
        date: "on " + this.getCurrentDate()
      };
    }
    //get recent matter details
    let settings = Office.context.roamingSettings;
    if (typeof settings.get("SelectedMattersList") !== "undefined") {
      let latestUsedMatters: any[];
      latestUsedMatters = settings.get("SelectedMattersList");
      if (latestUsedMatters.filter(x => x.MatterId === option.key).length > 0) {
        matter["url"] = latestUsedMatters.find(
          x => x.MatterId === option.key
        ).Url;
      }
    }
    isMounted &&
      this.setState({
        selectedMatter: matter,
        isRecentMatterChanged: true,
        errorMessage: "",
        isRequiredFieldsEmpty: false
      });
  };

  //update latest used matter list
  updateLatestUsedMatters = option => {
    let settings = Office.context.roamingSettings;
    if (typeof settings.get("SelectedMattersList") !== "undefined") {
      //get the available selected matters list
      let selectedMatters = [];
      selectedMatters = settings.get("SelectedMattersList");
      let count = selectedMatters.filter(x => x.MatterId === option.key).length;

      if (count === 0) {
        selectedMatters.push({
          Id: selectedMatters.length + 1,
          MatterId: option.Id,
          Name: option.text,
          Url: option.url
        });
        settings.set("SelectedMattersList", selectedMatters);
        settings.saveAsync(function (asyncResult) {
          if (asyncResult.status == Office.AsyncResultStatus.Failed) {
            console.error("Outlook failed to save SelectedMattersList...");
          } else {
            console.info("SelectedMattersList saved...");
          }
        });
      }
    } else {
      //save in roaming settings
      let selectedMatters = [];
      selectedMatters.push({
        Id: 1,
        MatterId: option.Id,
        Name: option.text,
        Url: option.url
      });
      settings.set("SelectedMattersList", selectedMatters);
      settings.saveAsync(function (asyncResult) {
        if (asyncResult.status == Office.AsyncResultStatus.Failed) {
          console.error("Outlook failed to save SelectedMattersList...");
        } else {
          console.info("SelectedMattersList saved...");
        }
      });
    }
  };
  //update selected attachments in state
  updateSelectedAttachmentList = attachments => {
    isMounted &&
      this.setState({
        selectedAttachments: attachments,
        isSelectedAttachmentsChanged: true
      });
  };
  // save email data
  postEmailPayLoadToMatter = accessToken => {
    let self = this;
    try {
      let body;
      let from = Office.context.mailbox.item.sender.emailAddress;
      let to = Office.context.mailbox.item.to;
      let date = new Date(Date.now()).toISOString();
      let { itemSubject } = this.state;
      let itemAttachments = Office.context.mailbox.item.attachments;
      let { selectedMatter, uploadedKeyList } = this.state;
      let uploadedAttachments = {};

      //get uploaded attachment details
      uploadedKeyList.forEach(attachment => {
        let attachmentObj = itemAttachments.find(
          x => x.id === attachment.AttachmentId
        );
        let obj = {
          name: attachmentObj.name,
          key: attachment.S3Key,
          size: attachmentObj.size,
          type: attachmentObj.contentType
        };
        uploadedAttachments[attachment.S3Key] = obj;
      });
      let settings = Office.context.roamingSettings;
      let workspaceUrlPrefix =
        typeof settings.get("WorkspaceURLPrefix") !== "undefined"
          ? settings.get("WorkspaceURLPrefix")
          : "eng-outlook";
      let workspaceUrltld =
        typeof settings.get("WorkspaceURLtld") !== "undefined"
          ? settings.get("WorkspaceURLtld")
          : "com";
      //get body of the email
      Office.context.mailbox.item.body.getAsync(
        Office.CoercionType.Text,
        function (asyncResult) {
          if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {
            console.error("Error occurred when getting the email body...");
            self.setState({
              isProcessing: false,
              errorMessage: "Failed to get email content. Please try again."
            });
            return;
          } else {
            body = asyncResult.value.trim() || "[No email content]";
            let params = {
              body: body,
              from_email: from,
              to_email: to[0].emailAddress,
              date: date,
              subject: itemSubject,
              id: Office.context.mailbox.item.itemId,
              attachments:
                Office.context.mailbox.item.attachments.length > 0
                  ? uploadedAttachments
                  : {}
            };

            axios
              .post(
                `${APIUrls.urlForEmailPayload(workspaceUrlPrefix, workspaceUrltld)}${selectedMatter.Id}/email/`,
                params,
                {
                  headers: {
                    Authorization: "Bearer " + accessToken
                  }
                }
              )
              .then(response => {
                if (response.status === 200) {
                  self.updateLatestUsedMatters(selectedMatter);
                  //save in custom properties
                  let item = Office.context.mailbox.item;
                  item.loadCustomPropertiesAsync(self.customPropsCallback);

                  ReactDOM.render(
                    <SuccessMessage
                      selectedMatter={self.state.selectedMatter}
                      isLoggedIn={self.props.isLoggedIn}
                      workspaceUrlPrefix={workspaceUrlPrefix}
                      workspaceUrltld={workspaceUrltld}
                    />,
                    document.getElementById("container")
                  );
                }
              })
              .catch(err => {
                if (err.response.status === 401) {
                  ReactDOM.render(
                    <SignIn />,
                    document.getElementById("container")
                  );
                } else {
                  self.getErrors(err.response.data);
                }
              });
          }
        }
      );
    } catch (error) {
      console.error('Failed to post email payload to matter...', error);
      this.setState({
        isProcessing: false,
        errorMessage: "Failed to save email. Please try again."
      });
    }
    this.setState({
      uploadedKeyList: []
    });
  };

  //subject on changed
  subjectOnChanged = data => {
    //isItemChanged = false;
    this.setState({ itemSubject: data.target.value, isStateChanged: true });
  };
  //show errors
  getErrors = data => {
    let errors = [];
    if (data.id && data.id.length > 0) {
      data.id.forEach(error => {
        errors.push(error);
      });
    }
    if (data.body && data.body.length > 0) {
      data.body.forEach(error => {
        errors.push(error);
      });
    }
    if (data.from && data.from.length > 0) {
      data.from.forEach(error => {
        errors.push(error);
      });
    }
    if (data.to && data.to.length > 0) {
      data.to.forEach(error => {
        errors.push(error);
      });
    }
    if (data.date && data.date.length > 0) {
      data.date.forEach(error => {
        errors.push(error);
      });
    }
    if (data.subject && data.subject.length > 0) {
      data.subject.forEach(error => {
        errors.push("Subject: " + error);
      });
    }
    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach(error => {
        errors.push(error);
      });
    }
    if (data.error) {
      errors.push(data.error);
    }
    this.setState({
      errorMessage: errors.join(","),
      isProcessing: false,
      isRequiredFieldsEmpty: false
    });
  };
  //get custom properties
  customPropsCallback = asyncResult => {
    let customProps = asyncResult.value;
    let { selectedMatter } = this.state;
    let savedMatters: any[] = [];
    savedMatters =
      typeof customProps.get("SavedMatters") !== "undefined"
        ? customProps.get("SavedMatters")
        : [];
    if (
      savedMatters.filter(x => x.MatterId === selectedMatter.Id).length === 0
    ) {
      savedMatters.push(selectedMatter);
    }
    customProps.set("SavedMatters", savedMatters);
    customProps.saveAsync(this.saveCallback);
  };
  //save call back
  saveCallback = asyncResult => {
    if (asyncResult.status == Office.AsyncResultStatus.Failed) {
      console.error('Outlook failed to save SavedMatters...');
    } else {
      console.info("SavedMatters saved...");
    }
  };
  getCurrentDate = (): string => {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let yyyy = today.getFullYear();
    let dateString = "";
    let monthString = "";
    let currentDate = "";

    if (dd < 10) {
      dateString = "0" + dd;
    } else {
      dateString = dd.toString();
    }

    if (mm < 10) {
      monthString = "0" + mm;
    } else {
      monthString = mm.toString();
    }
    currentDate = monthString + "/" + dateString + "/" + yyyy;
    return currentDate;
  };
}

export default SaveEmail;
